<template>
    <div class="footer">
        <div class="logo-box">
            <img src="../assets/logo.png" alt="">
            <span>PERUVIAN</span> SHELL S.A.C.
        </div>
        <div class="footer-text">¡Reserve su mesa o entretenimiento hoy! Programe fácilmente su próximo gran momento y déjenos cuidar de usted.</div>
        <div class="foot-info">
            <div class="item">
                <div>Nuestra dirección</div>
                <p>AV. GUARDIA PERUANA NRO. 669 URB. PASEO DE LA</p>
            </div>
            <div class="item">
                <div>Hora de apertura</div>
                <p>Domingo a viernes: 8:00 a. m. - 10:00 p. m.
                    Sábado: 10:00 a. m. - 04:00 p. m.
                    (Servicio de entrega 24*7 días)</p>
            </div>
            <div class="item">
                <div>Correo</div>
                <p>Laignoranciadamiedo@gmail.com</p>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'App',
    data() {
        return {
            value: ''
        }
    },
    mounted() {

    },
    methods: {
        sendEmail() {
            if (!this.value) {
                return alert('Email cannot be empty')
            }
            return alert('Sent successfully')
        }
    }
}
</script>


<style lang="less" scoped>
.footer {
    background: url(../assets/footer-box.png);
    padding: 0px 360px;
    height: 623px;
    background-size: 100% 100%;

    .logo-box {
        display: flex;
        align-items: center;
        justify-content: center;
        font-weight: 800;
        font-size: 26px;
        color: #FFF;
        padding-top: 105px;

        img {
            width: 60px;
            margin-right: 14px;
        }

        span {
            color: #FFA72C;
        }
    }

    .footer-text {
        font-weight: 400;
        font-size: 22px;
        color: #FFFFFF;
        padding: 50px;
        text-align: center;
        border-bottom: 1px solid #FFF;
    }

    .foot-info {
        margin-top: 80px;
        display: flex;
        align-items: self-start;
        justify-content: space-between;

        .item {
            text-align: center;
            width: 300px;

            div {
                font-weight: 400;
                font-size: 28px;
                color: #FFFFFF;
            }

            p {
                font-weight: 400;
                font-size: 20px;
                color: #FFFFFF;
                margin-top: 16px;
            }
        }
    }


}
</style>